module.exports = __webpack_public_path__ + "static/media/palomita_solita.3a6f6818.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Header/palomita_solita.svg
// module id = 1797
// module chunks = 0